import { inject } from '@angular/core';
import { CrmActivationHandleSuccessFunction } from '@touch4it/ng-swp/auth';
import { Router } from '@angular/router';

export const activationHandleSuccess: CrmActivationHandleSuccessFunction = () => {
  const router = inject(Router);

  return () => {
    router.navigateByUrl('/').then();
  };
};
